import {useState} from 'react';
import {useDispatch} from 'react-redux';
import {UPDATE_EVENT_DETAILS} from '~/CreateFabricInvitation/reducers/details/constants';
import {SET_UPSELL_CONFIRMED} from '~/CreateFabricInvitation/reducers/modals';
import {
  webViewModalShowing,
  webViewPendingUpgradeToPremium,
} from '~/CreateFabricInvitation/webview/webview';
import {REVERT_TO_BASIC} from '~/CreateFabricInvitation/reducers/fabricDesign/constants';
import {Sections} from '~/CreateFabricInvitation/routes/EventCreateDesign/constants';

export const useModals = ({navigate}) => {
  const dispatch = useDispatch();
  const [showUpsellModal, setShowUpsellModal] = useState(false);
  const [upsellModalMode, setUpsellModalMode] = useState('');
  const [showExitPremiumPreviewModal, setShowExitPremiumPreviewModal] = useState(false);

  const upgradeToPremium = () => {
    dispatch({
      type: UPDATE_EVENT_DETAILS,
      payload: {isPremium: true, hideUpsell: true},
    });
    dispatch({
      type: SET_UPSELL_CONFIRMED,
      payload: true,
    });
    window.dataLayer.push({
      event: 'fabric_create_upgrade_customize',
    });
    webViewPendingUpgradeToPremium(true);
  };

  const downgradeBackToBasic = () => {
    dispatch({
      type: REVERT_TO_BASIC,
    });
    dispatch({
      type: UPDATE_EVENT_DETAILS,
      payload: {isPremium: false},
    });
    window.dataLayer.push({
      event: 'fabric_create_downgrade_customize',
    });
    webViewPendingUpgradeToPremium(false);
    navigate(Sections.CARD_DESIGN);
    setShowExitPremiumPreviewModal(false);
  };

  const handleShowUpsell = () => {
    webViewModalShowing('upsell');
    setUpsellModalMode('unlock-design-tools');
    setShowUpsellModal(true);
  };

  return {
    showUpsellModal,
    upsellModalMode,
    showExitPremiumPreviewModal,
    setShowUpsellModal,
    setShowExitPremiumPreviewModal,
    upgradeToPremium,
    downgradeBackToBasic,
    handleShowUpsell,
  };
};
